import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import Radium, { StyleRoot } from 'radium'
import { connect } from 'react-redux'
import { CSSProperties } from 'react'
import { TBankerProofCard } from './TBankerProofCard'
import { CampusFeedback } from '../FlatPages/CampusFeedback'
import { CampusFooter } from '../Components/CampusFooter'
import * as Request from '../tgccRequest'
import { TBankerFooter } from './TBankerFooter'
import { TBankerHeader } from '../Components/TBankerHeader'
import { TBankerPurchase } from './TBankerPurchase'



const parentWrapperStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textTransform: 'uppercase',
    backgroundColor: 'rgb(244, 250, 255)',
    margin: '0px auto',
    borderRadius: '20px',
    '@media (max-width: 768px)': {
        margin: '0 10px', // Add margin on the sides for mobile view
        borderRadius: '10px', // Optional: Reduce border radius for mobile view
        width: '95%',
      },
}

const pageStyle: React.CSSProperties = {
    backgroundColor: 'rgb(244, 250, 255)',
    minHeight: '100vh', // Ensures it covers the whole viewport height
    width: '100vw', // Ensures it covers the whole viewport width
    '@media (max-width: 768px)': {
      },
}


const dashHdrLineR: CSSProperties = {
    width: '180px',
    backgroundColor: '#E9E6E6',
    height: '2px',
    display: 'inline-block',
    marginBottom: '8px',
    marginRight: '10px',
    '@media (max-width: 768px)': {
        width: '120px', // Reduce width for mobile view
        marginRight: '5px', // Adjust margin if necessary
      },
}

const dashHdrLineL: CSSProperties = {
    width: '180px',
    backgroundColor: '#E9E6E6',
    height: '2px',
    display: 'inline-block',
    marginBottom: '8px',
    marginLeft: '5px',
    '@media (max-width: 768px)': {
        width: '120px', // Reduce width for mobile view
        marginLeft: '5px', // Adjust margin if necessary
      },
}

const dashText: React.CSSProperties = {
    display: 'inline-block',
    letterSpacing: '0.3em',
    fontSize: '26px',
    fontFamily: 'Lulo',
    color: '#686868'
}
const createAcc: React.CSSProperties = {
    textAlign: 'center',
    marginTop: '-70px',
    display: 'none',
    '@media (max-width: 768px)': {
        marginTop: '0', // Adjust top margin for mobile view
      },
}

let errorStyle = Object.assign(
    {}, Tgcc.Styles.error, { 
        fontSize: '20px',
        '@media (max-width: 768px)': {
            fontSize: '16px', // Reduce font size for mobile view
        },
     });

class _Tbanker extends React.Component<Tgcc.BaseProps, any>{
    state = {
        isCampus: false,
        tbanker: null,
        error: null,
        isWaiting: true,
        purchaseCompleted: false
    };

    componentWillMount() {
        let tbCode = this.props.params.tbCode;
        
        if (!tbCode) {
            // Convert all query parameters to lowercase
            const queryParams = new URLSearchParams(this.props.location.search.toLowerCase());
            tbCode = queryParams.get('proofid');
        }
        
        const completed = this.props.location.query.completed;
        const isCampus = this.props.location.pathname.toUpperCase().indexOf("CAMPUS") > 0;
        const isCompleted = completed !== undefined || completed === null;
        
        this.setState({
            purchaseCompleted: isCompleted,
            isMajorAccts: isCampus
        });
        
        Request.getTbanker(tbCode, this.tbankerLoaded, this.loadError);
    }
    
    
    componentDidMount() {
        var tag = document.getElementById('campusTbanker');
        tag.scrollIntoView(false);
    }

    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    tbankerLoaded = (info: Tgcc.TbankerInfo) => {
        this.setState({ tbanker: info, isWaiting: false });
    }

    loadError = (err: string) => {
        this.setState({ error: err, isWaiting: false });
        console.log("error loading tbanker: ", err);
    }

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }

    getDashHeader = () => {
        return this.state.isCampus
            ? <div />
            : <div style={createAcc} className="maTBanker">
                <div style={dashHdrLineR}></div>
                {/* <h1 id ='dashText' style={dashText}>{this.state.tbanker.proofId}</h1> */}
                <div style={dashHdrLineL}></div>
            </div>
    }

    getHeader = () => {
        return this.state.isCampus
            ? <CampusFeedback state={this.props.state} />
            : <TBankerHeader />
    }

    getFooter = () => {
        return this.state.isCampus
            ? <CampusFooter state={this.props.state} />
            : <TBankerFooter state={this.props.state} />
    }

    render() {
        var completed = this.state.purchaseCompleted;
        var error = this.state.error ? <div style={errorStyle}>{this.state.error}</div> : null;
        var tbanker = this.state.tbanker;
        var content = null;
        if (tbanker) {
            content = (
                <div style={parentWrapperStyle} className="campusTBankerBox">
                    {this.getDashHeader()}
                    <TBankerProofCard tbanker={tbanker} proofId={tbanker.proofId} />
                    <TBankerPurchase tbanker={tbanker} purchaseComplete={completed} />
                </div>
            );
        } else {
            content = (
                <div style={parentWrapperStyle}>
                    <div style={Tgcc.Styles.error}>{this.state.error}</div>
                </div>
            );

        }

        return (
            <StyleRoot>
            <div style={pageStyle}>
                <div id='campusTbanker'></div>
                {this.getHeader()}
                {content}
                {this.getFooter()}
            </div>
            </StyleRoot>
        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return { state: state }
};

export var TBanker = connect(mapStateToProps)(Radium(_Tbanker));

